import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React__default, { useRef, useCallback, useMemo } from 'react';
import MuiBox from '@mui/material/Box';
import MuiTypography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Hint from '../Hint/Hint.js';

const Root = styled(MuiBox, { shouldForwardProp: prop => prop !== 'disabled' }) `
  display: flex;
  align-items: center;
  flex-direction: row;
  width: fit-content;
  ${({ theme, disabled }) => `
    color: ${theme.palette[disabled ? 'N30' : 'N10'].main};
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    ${!disabled &&
    `&:hover {
        color: ${theme.palette.primary.main};
      }`};
  `}
`;
const Text = styled(MuiTypography) `
  ${({ theme }) => `
    margin: ${theme.spacing(0, 0, 0, 3)};
  `}
`;
const Label = (_a) => {
    var { control, children, disabled, hint, hintDuration, labelVariant = 'body1', 'data-testid': testId } = _a, rest = __rest(_a, ["control", "children", "disabled", "hint", "hintDuration", "labelVariant", 'data-testid']);
    const inputRef = useRef(null);
    const onWrapperClick = useCallback(() => {
        if (!disabled && (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current)) {
            inputRef.current.click();
        }
    }, [disabled, inputRef]);
    const label = useMemo(() => {
        if (!children) {
            return null;
        }
        else if (React__default.isValidElement(children)) {
            return children;
        }
        return jsx(Text, Object.assign({ variant: labelVariant }, { children: children }));
    }, [children, labelVariant]);
    const onControlClick = (event) => {
        event.stopPropagation();
    };
    return (jsx(Hint, Object.assign({ title: hint, duration: hintDuration }, { children: jsxs(Root, Object.assign({}, rest, { onClick: onWrapperClick, disabled: disabled, "data-testid": testId }, { children: [React__default.cloneElement(control, {
                    inputRef,
                    onClick: onControlClick,
                }), label] })) })));
};

export { Label as default };
//# sourceMappingURL=Label.js.map
